import { HStack } from '@chakra-ui/react'
import { SecondaryButton } from 'components/Buttons'
import React from 'react'
import { VscSettings } from 'react-icons/vsc'

const styles = {
  mr: 2,
  my: 3,
  height: 10,
  fontSize: 'xs',
  rounded: 'full',
  borderWidth: 1
}
type FilterOptionsProps = {
  setActiveFilter: React.Dispatch<React.SetStateAction<any>>
  filter: any
  options: Array<{ label: string; value: any }>
}

const FilterOptions: React.FC<FilterOptionsProps> = ({ setActiveFilter, filter, options }) => {
  return (
    <HStack align="center">
      <VscSettings />
      {options.map((option) => (
        <SecondaryButton
          key={option.value}
          {...styles}
          borderColor={filter === option.value ? 'orange.200' : 'gray.100'}
          backgroundColor={filter === option.value ? 'orange.50' : 'gray.100'}
          onClick={() => setActiveFilter(option.value)}
        >
          {option.label}
        </SecondaryButton>
      ))}
    </HStack>
  )
}

export default FilterOptions
